'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [].slice.call(document.styleSheets).reduce(function (prev, styleSheet) {
    try {
      var styles = !!styleSheet.cssRules ? prev + [].slice.call(styleSheet.cssRules).reduce(function (prev, cssRule) {
        return '' + prev + cssRule.cssText;
      }, '') : prev;
      return styles;
    } catch (error) {
      console.log(error);
      return prev;
    }
  }, '');
};